type FetchCacheStoredObject = import('modules/with-fetch').FetchCacheStoredObject;

const saveCacheEntryToStorage = async (
  key: string,
  value: FetchCacheStoredObject,
): Promise<void> => {};

export default saveCacheEntryToStorage;
